import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';
import { IRegisterBadgeCommand } from './types';

const getBadge = (command: IRegisterBadgeCommand): AxiosPromise =>
  instance.post('/api/badges', command);

export default getBadge;
